(function() {
  'use strict';

  angular
    .module('html', ['ngAnimate', 'ngCookies', 'ngTouch', 'ngSanitize', 'ngMessages', 'ngAria', 'ngResource', 'ui.router', 'ui.bootstrap']);

})();

(function() {
  'use strict';

  angular
    .module('html')
    .directive('acmeNavbar', acmeNavbar);

  /** @ngInject */
  function acmeNavbar() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/navbar/navbar.html',
      scope: {
          creationDate: '='
      },
      controller: NavbarController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function NavbarController(moment) {
      var vm = this;

      // "vm.creation" is avaible by directive option "bindToController: true"
      vm.relativeDate = moment(vm.creationDate).fromNow();
    }
  }

})();

/* global _:false */
(function() {
  'use strict';

  angular
    .module('html')
    .controller('MainController', MainController);

  /** @ngInject */
  function MainController($scope, $window, $http, $timeout, $log, $document, $sce) {

    var vm = this;

    vm.data = [];
    vm.navItem = null;

    vm.inactiveTime = 0;
    vm.inactiveMax = 600;

    vm.hideHappy = false;
    vm.closeHappy = function() {
      vm.hideHappy = true;
    };

    /**
     * Check for Mobile and Safari,
     * since they require extra logic...
     */
    var isMobile = function() {
      var check = false;
      (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
      return check;
    };
    vm.mobile = isMobile();
    vm.safari = !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/);

    // click house...
    vm.houseClick = function() {

      angular.element('.main-house, .house-full').removeClass('ani-navi-in');

      vm.data.map(function(item) {

        item.open = false;

        angular.element('#navi' + item.id).removeClass('ani-navi-in');
        angular.element('.room' + item.id).removeClass('ani-room-out');
        angular.element('.icon' + item.id).removeClass('ani-icon-in');

        angular.element('.hot' + item.id).show();

        angular.element('#navi' + item.id + ' .navi-vid-texts .text-img').removeClass('ani-text-in');
      });

      angular.element('.room-extra').addClass('ani-room-out');
      angular.element('.icon-extra').removeClass('ani-icon-in');

      if (vm.navItem) {
        angular.element('#navi-video' + vm.navItem.id)[0].pause();
        angular.element('#house' + vm.navItem.id).removeClass('ani-house-in');
        $timeout(function() {
          vm.navItem = null;
        }, 0);
      }
    };

    // show video related to selected room...
    vm.showRoomVideo = function(nav) {
      vm.navItem = nav;
      vm.showHotspots(nav.id);
    };

    // show video related to selected house...
    vm.showHouseVideo = function(nav) {
      if (vm.navItem){
        angular.element('#house' + vm.navItem.id).removeClass('ani-house-in');
      }
      vm.showRoomVideo(nav);
      angular.element('#house' + nav.id).addClass('ani-house-in');
    };

    // close navi...
    vm.closeNav = function() {
      vm.navItem.open = false;
      angular.element('#navi-video' + vm.navItem.id)[0].pause();
      angular.element('#navi' + vm.navItem.id + ' .navi-vid-texts .text-img').removeClass('ani-text-in');
      angular.element('.navi-item').removeClass('navi-hidden');
      $timeout(function() {
        vm.navItem = null;
      }, 250);
    };

    vm.playVideo = function(navId) {
      angular.element('#navi-video' + navId)[0].currentTime = 0;
      angular.element('#navi-video' + navId)[0].play();
      angular.element('.navi-play-button').addClass('dont-show');
    };

    // open navi...
    vm.navClick = function(nav) {

      if (vm.navItem && nav.id === vm.navItem.id) {
        // $log.debug('do nothing');
      } else {

        if (vm.navItem) {
          vm.navItem.open = false;
          angular.element('#navi-video' + vm.navItem.id)[0].pause();
          angular.element('#navi' + vm.navItem.id + ' .navi-vid-texts .text-img').removeClass('ani-text-in');
        }

        // If is mobile, hide other nav items...
        if (vm.mobile) {
          angular.element('.navi-item').map(function(index, el) {
            if (!angular.element(el).hasClass('navi-item' + nav.id)) {
              angular.element(el).addClass('navi-hidden');
            }
          });
        }

        nav.open = true;
        vm.showHouseVideo(nav);

        $timeout(function() {
          angular.element('#navi' + nav.id + ' .navi-vid-texts .text-img').addClass('ani-text-in');
        }, 600);

        $timeout(function() {
          if (!vm.safari) {
            angular.element('#navi-video' + vm.navItem.id)[0].currentTime = 0;
            angular.element('#navi-video' + vm.navItem.id)[0].play();
          }
        }, 1000);

      }
    };

    // show nav...
    vm.showNav = function() {
      vm.data.map(function(item, index) {
        var t = 200 * index + 100;
        var el = angular.element('#navi' + item.id);
        $timeout(function() {
          el.addClass('ani-navi-in');
        }, t);
      });
    };

    // hide nav...
    vm.hideNav = function() {
      angular.element('.navi-item').removeClass('ani-navi-in');
    };

    // show hotspots
    vm.showHotspots = function(id) {
      vm.data.map(function(item) {
        angular.element('.hot' + item.id).hide();
        var icon = angular.element('.icon' + item.id);
        if (item.id === id) {
          icon.removeClass('ani-icon-in');
        } else icon.addClass('ani-icon-in');
      });
    };

    // click hotspot...
    vm.hotspotClick = function(hotspot) {

      var nav = vm.data.filter(function(item) {
        return item.id === hotspot.id;
      })[0];

      if (vm.navItem) {
        vm.navClick(nav);
      } else {

        angular.element('.main-house').addClass('ani-navi-in');

        vm.showNav();
        vm.showHotspots(nav.id);

        $timeout(function() {
          vm.navClick(nav);
        }, 1500);
      }
    };

    // init...
    var loadApp = function() {

      var houseFull = angular.element('.house-full');
      var houseMain = angular.element('.main-house');

      houseMain.addClass('ani-house-in');
      houseFull.addClass('ani-house-in');

      // if smalled viewport...
      if ($window.innerWidth <= 991) {
        // if mobile...
        if (!vm.mobile) {
          vm.navClick(_.head(vm.data));
        }
        vm.showNav();
      }
    };

    // Load data and start
    // $http.get('assets/data/page.json').then(function(res) {
    //   // store data and make video angular friendly...
    //   vm.data = res.data.map(function(item) {
    //     return _.set(item, 'video', $sce.trustAsResourceUrl('assets/videos/' + item.video));
    //   });
    //   loadApp();
    // });

    // Load pageJSON here to enable offline usage
    var page = [
      {
        "id": "1",
        "title": "Tehokas",
        "header": "tehokas",
        "icon": "icon-g-tehokas.png",
        "hotspotw": 101,
        "hotspoth": 16,
        "room": "room_efficient.jpg",
        "house": "house_efficient.jpg",
        "left": 1200,
        "top": 365,
        "width": 370,
        "height": 225,
        "video": "more_efficient.mp4",
        "times":
        {
          "in":
          {
            "start": 17000,
            "end": 18000,
            "duration": 1000
          },
          "loop":
          {
            "start": 18000,
            "end": 19000,
            "duration": 1000
          },
          "out":
          {
            "start": 19000,
            "end": 19600,
            "duration": 600
          }
        },
        "open": false,
        "vidtexts": "se_finnbuild_nostot_tehokas.svg"
      },
      {
        "id": "2",
        "title": "Pilvipalvelut",
        "header": "pilvipalvelut",
        "icon": "icon-g-pilvipalvelut.png",
        "hotspotw": 151,
        "hotspoth": 16,
        "room": "room_connected1.jpg",
        "house": "house_connected.jpg",
        "left": 335,
        "top": 125,
        "width": 495,
        "height": 230,
        "video": "more_connected.mp4",
        "times":
        {
          "in":
          {
            "start": 1000,
            "end": 2000,
            "duration": 1000
          },
          "loop":
          {
            "start": 2000,
            "end": 3000,
            "duration": 1000
          },
          "out":
          {
            "start": 3000,
            "end": 3600,
            "duration": 600
          }
        },
        "open": false,
        "vidtexts": "se_finnbuild_nostot_pilvipalvelut.svg"
      },
      {
        "id": "3",
        "title": "Älykäs",
        "header": "alykas",
        "icon": "icon-g-alykas.png",
        "hotspotw": 83,
        "hotspoth": 20,
        "room": "room_smart.jpg",
        "house": "house_smart.jpg",
        "left": 640,
        "top": 840,
        "width": 430,
        "height": 220,
        "video": "more_smart.mp4",
        "times":
        {
          "in":
          {
            "start": 13000,
            "end": 14000,
            "duration": 1000
          },
          "loop":
          {
            "start": 14000,
            "end": 15000,
            "duration": 1000
          },
          "out":
          {
            "start": 15000,
            "end": 15600,
            "duration": 600
          }
        },
        "open": false,
        "vidtexts": "se_finnbuild_nostot_alykas.svg"
      },
      {
        "id": "4",
        "title": "Turvallinen",
        "header": "turvallinen",
        "icon": "icon-g-turvallinen.png",
        "hotspotw": 143,
        "hotspoth": 16,
        "room": "room_safe.jpg",
        "house": "house_safe.jpg",
        "left": 1080,
        "top": 840,
        "width": 480,
        "height": 220,
        "video": "more_safe.mp4",
        "times":
        {
          "in":
          {
            "start": 9000,
            "end": 10000,
            "duration": 1000
          },
          "loop":
          {
            "start": 10000,
            "end": 11000,
            "duration": 1000
          },
          "out":
          {
            "start": 11000,
            "end": 11600,
            "duration": 600
          }
        },
        "open": false,
        "vidtexts": "se_finnbuild_nostot_turvallisuus.svg"
      },
      {
        "id": "5",
        "title": "Viihtyisä",
        "header": "viihtyisa",
        "icon": "icon-g-viihtyisa.png",
        "hotspotw": 106,
        "hotspoth": 20,
        "room": "room_comfort.jpg",
        "house": "house_comfort.jpg",
        "left": 670,
        "top": 365,
        "width": 510,
        "height": 230,
        "video": "more_comfort.mp4",
        "times":
        {
          "in":
          {
            "start": 5000,
            "end": 6000,
            "duration": 1000
          },
          "loop":
          {
            "start": 6000,
            "end": 7000,
            "duration": 1000
          },
          "out":
          {
            "start": 7000,
            "end": 7600,
            "duration": 600
          }
        },
        "open": false,
        "vidtexts": "se_finnbuild_nostot_viihtyisa.svg"
      },
      {
        "id": "6",
        "title": "Mukautuva",
        "header": "mukautuva",
        "icon": "icon-g-mukautuva.png",
        "hotspotw": 131,
        "hotspoth": 16,
        "room": "room_sustainable.jpg",
        "house": "house_sustainable.jpg",
        "left": 860,
        "top": 125,
        "width": 705,
        "height": 230,
        "video": "more_sustainable_1.mp4",
        "times":
        {
          "in":
          {
            "start": 21000,
            "end": 24000,
            "duration": 3000
          },
          "loop":
          {
            "start": 24000,
            "end": 25000,
            "duration": 1000
          },
          "out":
          {
            "start": 25000,
            "end": 25600,
            "duration": 600
          }
        },
        "open": false,
        "vidtexts": "se_finnbuild_nostot_mukautuva.svg"
      }
    ];
    vm.data = page.map(function(item) {
      return _.set(item, 'video', $sce.trustAsResourceUrl('assets/videos/' + item.video));
    });
    loadApp();



    // handle resize
    angular.element($window).on('resize', _.throttle(function() {
      if (!vm.navItem) {
        if ($window.innerWidth >= 991) {
          if (angular.element('.house-highlite').hasClass('ani-house-in')) {
            $timeout(function() {
              vm.houseClick();
              angular.element('.house-highlite').removeClass('ani-house-in');
            }, 0);
          }
        }
      } else {
        if ($window.innerWidth >= 992) {
          if (!angular.element('.main-house').hasClass('ani-navi-in')) {
            angular.element('.main-house').addClass('ani-navi-in');
            vm.showNav();
          }
        }
      }
    }, 100));

  }
})();

(function() {
  'use strict';

  angular
    .module('html')
    .run(runBlock);

  /** @ngInject */
  function runBlock() {}

})();

(function() {
  'use strict';

  angular
    .module('html')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('home', {
        url: '/',
        templateUrl: 'app/main/main.html',
        controller: 'MainController',
        controllerAs: 'main'
      });

    $urlRouterProvider.otherwise('/');
  }

})();

/* global moment:false */
(function() {
  'use strict';

  angular
    .module('html')
    .constant('moment', moment);

})();

(function() {
  'use strict';

  angular
    .module('html')
    .config(config);

  /** @ngInject */
  function config($logProvider, $compileProvider, $locationProvider, $sceDelegateProvider) {
    // Enable log
    $logProvider.debugEnabled(true);
    $compileProvider.debugInfoEnabled(false);
    
    // $locationProvider.html5Mode(true).hashPrefix('!');

    $sceDelegateProvider.resourceUrlWhitelist([
      // Allow same origin resource loads.
      'self',
      'http://localhost',
      // Allow loading from our assets domain.  Notice the difference between * and **.
      'http://playground.kuubi.fi/**',
      'https://playground.kuubi.fi/**'
    ]);
  }

})();

angular.module("html").run(["$templateCache", function($templateCache) {$templateCache.put("app/main/main.html","<div class=\"container main-content\"><section class=\"main-house\"><div class=\"the-house\"><div class=\"house-holder\"><div class=\"house-full\" ng-click=\"main.houseClick()\"><div ng-repeat=\"house in main.data\" class=\"house-highlite\" id=\"house{{ house.id }}\" ng-style=\"{ \'background-image\': \'url(assets/images/house/{{house.house}})\' }\"></div></div><div ng-repeat=\"room in main.data\" class=\"house-room room{{ room.id }}\" ng-style=\"{ \'left\': \'{{ room.left }}px\', top: \'{{ room.top }}px\', width: \'{{ room.width }}px\', height: \'{{ room.height }}px\' }\"><div class=\"house-icon\"><div class=\"icon\" ng-class=\"\'icon{{ room.id }}\'\" ng-style=\"{ \'background-image\': \'url(assets/images/icons/{{ room.icon }})\' }\" ng-click=\"main.hotspotClick(room)\"></div></div><div class=\"house-hotspot\"><div class=\"hotspot\" ng-class=\"\'hot{{ room.id }}\'\" ng-style=\"{ \'background-image\': \'url(assets/images/icons/{{ room.icon }})\' }\" ng-click=\"main.hotspotClick(room)\"><div class=\"hotspot-title\" data-hotspot=\"{{ room.header }}\" ng-if=\"!navi.open\"></div></div></div></div></div></div></section><section class=\"main-navi\" ng-class=\"{ \'has-nav\': main.navItem }\"><div class=\"navi-content\"><div ng-repeat=\"navi in main.data\" class=\"navi-item navi-item{{ navi.id }}\" id=\"navi{{ navi.id }}\" ng-class=\"{ \'navi-open\': navi.open }\" ng-click=\"main.navClick(navi)\"><div class=\"navi-title\" data-navi=\"{{ navi.header }}\"></div><div class=\"navi-vid-player\" ng-if=\"navi.open\"><div class=\"navi-vid-player--container\"><video id=\"navi-video{{ navi.id }}\" class=\"video-player\" loop=\"\" playsinline=\"\"><source ng-src=\"{{ navi.video }}\" type=\"video/mp4\"></video></div><div class=\"navi-play-button\" ng-class=\"{ \'safari-play\': main.safari }\" ng-if=\"main.safari\" ng-click=\"main.playVideo(navi.id)\"><span></span></div></div><div class=\"navi-vid-text\" data-navtxt=\"{{ navi.header }}\" ng-if=\"navi.open\"><span></span></div><button class=\"navi-close\" ng-click=\"main.closeNav()\">Sulje</button></div></div></section><section class=\"main-logo\"><img src=\"assets/images/logo_schneider_lio.png\"></section></div>");
$templateCache.put("app/components/navbar/navbar.html","<nav class=\"navbar navbar-static-top navbar-inverse\"><div class=\"container-fluid\"><div class=\"navbar-header\"><a class=\"navbar-brand\" href=\"https://github.com/Swiip/generator-gulp-angular\"><span class=\"glyphicon glyphicon-home\"></span> Gulp Angular</a></div><div class=\"collapse navbar-collapse\" id=\"bs-example-navbar-collapse-6\"><ul class=\"nav navbar-nav\"><li class=\"active\"><a ng-href=\"#\">Home</a></li><li><a ng-href=\"#\">About</a></li><li><a ng-href=\"#\">Contact</a></li></ul><ul class=\"nav navbar-nav navbar-right acme-navbar-text\"><li>Application was created {{ vm.relativeDate }}.</li></ul></div></div></nav>");}]);